import { TextFieldWithEllipsis } from "UI/TextFiledWithEllipsis";
import Status from "./Status";
import { displayCreatedAt } from "utils/helpers";

export const superAdminNotificationsColumns = [
  {
    label: "Created At",
    field: "createdAt",
    xs: 1.5,
    sm: 1.5,
    md: 1.5,
    renderer: displayCreatedAt,
  },
  // {
  //   label: "Type",
  //   field: "type",
  //   xs: 1,
  //   sm: 1,
  //   md: 1,
  //   renderer: ({ type }) => (
  //     <TextFieldWithEllipsis>{type}</TextFieldWithEllipsis>
  //   ),
  // },
  // {
  //   label: "Button ID",
  //   field: "buttonId",
  //   xs: 1,
  //   sm: 1,
  //   md: 1,
  //   renderer: ({ buttonId, buttonType }) => (
  //     <TextFieldWithEllipsis>
  //       {["Virtual", "Soft", "Digital"].includes(buttonType)
  //         ? `${String(buttonId).slice(0, 8)}...`
  //         : buttonId}
  //     </TextFieldWithEllipsis>
  //   ),
  // },
  // {
  //   label: "Name",
  //   field: "buttonName",
  //   xs: 0.75,
  //   sm: 0.75,
  //   md: 0.75,
  //   renderer: ({ buttonName }) => (
  //     <TextFieldWithEllipsis>{buttonName}</TextFieldWithEllipsis>
  //   ),
  // },
  // {
  //   label: "Type",
  //   xs: 1,
  //   sm: 1,
  //   md: 1,
  //   renderer: ({ buttonType }) => (
  //     <TextFieldWithEllipsis>
  //       {convertDeviceType(buttonType)}
  //     </TextFieldWithEllipsis>
  //   ),
  // },
  {
    label: "Practice",
    field: "practiceName",
    xs: 2,
    sm: 2,
    md: 2,
    renderer: ({ practiceName }) => (
      <TextFieldWithEllipsis>{practiceName}</TextFieldWithEllipsis>
    ),
  },
  // {
  //   label: "Speciality",
  //   field: "practiceSpeciality",
  //   xs: 1,
  //   sm: 1,
  //   md: 1,
  //   renderer: ({ practiceSpeciality }) => (
  //     <TextFieldWithEllipsis>{practiceSpeciality}</TextFieldWithEllipsis>
  //   ),
  // },
  {
    label: "Provider",
    field: "providers",
    xs: 1.75,
    sm: 1.75,
    md: 1.75,
    renderer: ({ providers }) => (
      <TextFieldWithEllipsis>{providers}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Sender",
    field: "originatorName",
    xs: 1.75,
    sm: 1.75,
    md: 1.75,
    renderer: ({ originatorName }) => (
      <TextFieldWithEllipsis>{originatorName}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Sender Phone",
    field: "originatorPhone",
    xs: 1.25,
    sm: 1.25,
    md: 1.25,
    renderer: ({ originatorPhone }) => (
      <TextFieldWithEllipsis>{originatorPhone}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Recipient",
    field: "recipientName",
    xs: 1.5,
    sm: 1.5,
    md: 1.5,
    renderer: ({ recipientName }) => (
      <TextFieldWithEllipsis>{recipientName}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Specialists",
    field: "specialists",
    xs: 1.5,
    sm: 1.5,
    md: 1.5,
    renderer: ({ specialists }) => (
      <TextFieldWithEllipsis>{specialists}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Status",
    field: "status",
    xs: 0.75,
    sm: 0.75,
    md: 0.75,
    renderer: ({ status }) => <Status value={status} />,
  },
];

export const superAdminNotificationsMobileColumns = [
  {
    label: "Created At",
    field: "createdAt",
    xs: 4,
    sm: 4,
    md: 4,
    renderer: displayCreatedAt,
  },
  // {
  //   label: "Type",
  //   field: "type",
  //   xs: 2,
  //   sm: 2,
  //   md: 2,
  //   renderer: ({ type }) => (
  //     <TextFieldWithEllipsis>{type}</TextFieldWithEllipsis>
  //   ),
  // },
  {
    label: "Practice",
    field: "practiceName",
    xs: 3,
    sm: 3,
    md: 3,
    renderer: ({ practiceName }) => (
      <TextFieldWithEllipsis>{practiceName}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Recipient",
    field: "recipientName",
    xs: 3,
    sm: 3,
    md: 3,
    renderer: ({ recipientName }) => (
      <TextFieldWithEllipsis>{recipientName}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Status",
    field: "status",
    xs: 2,
    sm: 2,
    md: 2,
    renderer: ({ status }) => <Status value={status} />,
  },
];
